import React, { useState, useEffect } from "react";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { toast } from "react-toastify";
import { useLoad } from "../../context";
import ApiServices from "../../services/apiServices";
import Mask from "../../services/mask";
import Utils from "../../services/serviceUtils";
import logoLeo from "../../assets/images/pngs/logo_leo.png";
import logoFormobile from "../../assets/images/pngs/ForMobile_logo.png";
import "./index.css";

// Página deslogada da feira ForMóbile 2026 (RD 92871).
// Telas do esboço: inicial (4), busca SIM (5), encontrado (6), voucher (7),
// não encontrado (8), penca já resgatou (9), NÃO selecionado (11).
export default function Formobile() {
  const { setLoad } = useLoad();

  useEffect(() => {
    document.body.classList.add("page-formobile");
    return () => document.body.classList.remove("page-formobile");
  }, []);


  // "" (não respondeu) | "sim" | "nao"
  const [fazParte, setFazParte] = useState("");
  const [documento, setDocumento] = useState("");
  const [alerta, setAlerta] = useState("");

  // Estado do resultado da busca/resgate.
  // null | { naoEncontrado, jaResgatadoPenca, nomeQuemResgatou, nome, temDireito, descricaoBrinde, celular, email, categoria, saldo }
  const [resultado, setResultado] = useState(null);
  const [voucher, setVoucher] = useState("");

  const [editando, setEditando] = useState(false);
  const [celularEdit, setCelularEdit] = useState("");
  const [emailEdit, setEmailEdit] = useState("");
  const [cadastroSalvo, setCadastroSalvo] = useState(false);


  function limparResultado() {
    setResultado(null);
    setVoucher("");
    setAlerta("");
    setEditando(false);
    setCadastroSalvo(false);
  }

  function onChangeFazParte(valor) {
    setFazParte(valor);
    setDocumento("");
    limparResultado();
  }

  function onChangeDocumento(valor) {
    setDocumento(Mask.unMask(valor));
    if (resultado || voucher) limparResultado();
  }

  function documentoValido() {
    if (Utils.valida_cpf_cnpj(documento) !== true) {
      setAlerta("Informe um CPF ou CNPJ válido.");
      return false;
    }
    setAlerta("");
    return true;
  }

  async function buscar() {
    if (!documentoValido()) return;

    try {
      setLoad(true);
      const response = await ApiServices.apiPostAnonimo("formobile/buscar", {
        documento,
      });

      if (response?.statusCode === 200) {
        setResultado(response.data);
        setVoucher("");
      } else {
        setResultado(null);
        toast.error(response?.message || "Não foi possível realizar a busca.");
      }
    } catch (err) {
      console.error("err", err);
      toast.error("Não foi possível realizar a busca.");
    } finally {
      setLoad(false);
    }
  }

  function habilitarEdicao() {
    setCelularEdit(resultado?.celular || "");
    setEmailEdit(resultado?.email || "");
    setEditando(true);
  }

  async function salvarCadastro() {
    const emailAlterado = emailEdit.trim() !== (resultado?.email || "").trim();
    const celularAlterado = celularEdit.trim() !== (resultado?.celular || "").trim();

    if (!emailAlterado && !celularAlterado) {
      toast.info("Nenhum dado foi alterado.");
      return;
    }

    try {
      setLoad(true);
      const response = await ApiServices.apiPostAnonimo(
        "formobile/atualizar-cadastro",
        {
          documento,
          email: emailAlterado ? emailEdit.trim() : null,
          telefone: celularAlterado ? celularEdit.trim() : null,
        }
      );

      if (response?.statusCode === 200) {
        toast.success("Dados atualizados com sucesso!");
        setEditando(false);
        setCadastroSalvo(true);
      } else {
        toast.error(
          response?.message || "Não foi possível salvar os dados."
        );
      }
    } catch (err) {
      console.error("err", err);
      toast.error("Não foi possível salvar os dados.");
    } finally {
      setLoad(false);
    }
  }


  async function resgatar() {
    try {
      setLoad(true);
      const response = await ApiServices.apiPostAnonimo("formobile/resgatar", {
        documento,
      });

      if (response?.statusCode === 200) {
        setVoucher(response.data.voucher);
      } else {
        // Regras de negócio (ex.: penca já resgatou) chegam como mensagem.
        toast.error(response?.message || "Não foi possível resgatar o brinde.");
        // Reflete o bloqueio de penca na tela, se for o caso.
        await buscar();
      }
    } catch (err) {
      console.error("err", err);
      toast.error("Não foi possível resgatar o brinde.");
    } finally {
      setLoad(false);
    }
  }

  return (
    <div className="formobile">
      <header className="formobile-header">
        <img className="formobile-logo" src={logoLeo} alt="Leo Madeiras" />
        <h1>Seja bem-vindo a ForMóbile 2026</h1>
        <img className="formobile-logo-right" src={logoFormobile} alt="ForMóbile" />
      </header>

      <main className="formobile-conteudo">
        <p className="formobile-pergunta">Faz parte do Programa Amigo Leo?</p>

        <RadioGroup
          row
          className="formobile-radios"
          value={fazParte}
          onChange={(e) => onChangeFazParte(e.target.value)}
        >
          <FormControlLabel value="sim" control={<Radio />} label="SIM" />
          <FormControlLabel value="nao" control={<Radio />} label="NÃO" />
        </RadioGroup>

        {/* Selecionou NÃO (telas 10 e 11) */}
        {fazParte === "nao" && (
          <div className="formobile-mensagem">
            <p>
              Por favor, procure um de nossos representantes durante o evento
              para que possamos ajudá-lo.
            </p>
            <strong>OBRIGADA!</strong>
          </div>
        )}

        {/* Selecionou SIM (telas 5 a 9) */}
        {fazParte === "sim" && (
          <div className="formobile-busca">
            <TextField
              fullWidth
              label="Informe seu CPF ou CNPJ vinculado ao Amigo Leo"
              value={Mask.cpfCnpj(documento)}
              onChange={(e) => onChangeDocumento(e.target.value)}
              inputProps={{ inputMode: "text", maxLength: 18 }}
            />
            {alerta && <span className="formobile-alerta">{alerta}</span>}

            {/* Antes de buscar / sem voucher gerado */}
            {!voucher && (
              <button
                type="button"
                className="btn btn-warning formobile-btn"
                onClick={buscar}
              >
                BUSCAR
              </button>
            )}

            {/* Documento não encontrado (tela 8) */}
            {resultado?.naoEncontrado && (
              <div className="formobile-mensagem">
                <p>
                  Não localizamos seu cadastro em nossa base. Por favor, procure
                  um de nossos representantes durante o evento para que possamos
                  ajudá-lo.
                </p>
              </div>
            )}

            {/* Penca já resgatou (tela 9) */}
            {resultado?.jaResgatadoPenca && (
              <div className="formobile-mensagem">
                {resultado.nome && <p>Olá, {resultado.nome}!</p>}
                <p>
                  O participante "{resultado.nomeQuemResgatou}", que faz parte da
                  sua penca, já realizou a retirada do brinde.
                </p>
              </div>
            )}

            {/* Encontrado e com direito, ainda não resgatou (tela 6) */}
            {resultado?.temDireito && !voucher && (
              <div className="formobile-direito">
                <p className="formobile-saudacao">Olá, {resultado.nome}!</p>
                <p>
                  Você tem direito ao brinde exclusivo{" "}
                  <strong>{resultado.descricaoBrinde}</strong>
                </p>
                <button
                  type="button"
                  className="btn btn-warning formobile-btn"
                  onClick={resgatar}
                >
                  RESGATAR
                </button>
              </div>
            )}

            {/* Seção de validação/atualização de dados (FF 93510) */}
            {resultado?.nome && !resultado?.naoEncontrado && !voucher && (
              <div className="formobile-validacao">
                <p className="formobile-validacao-msg">
                  Antes do resgate, poderia validar os dados de E-mail e Telefone
                  que temos em nossa base? Caso seja necessária atualização,{" "}
                  {!editando && !cadastroSalvo && (
                    <span
                      className="formobile-clique-aqui"
                      onClick={habilitarEdicao}
                    >
                      clique aqui
                    </span>
                  )}
                  {(editando || cadastroSalvo) && <strong>edite abaixo</strong>}
                </p>
                <div className="formobile-validacao-campos">
                  <div className={`formobile-campo ${editando ? "formobile-campo-editavel" : ""}`}>
                    <label className="formobile-campo-label">Celular</label>
                    {editando ? (
                      <TextField
                        size="small"
                        fullWidth
                        value={celularEdit}
                        onChange={(e) => setCelularEdit(e.target.value)}
                        inputProps={{ maxLength: 20 }}
                      />
                    ) : (
                      <span className="formobile-campo-valor">
                        {resultado?.celular || "-"}
                      </span>
                    )}
                  </div>
                  <div className={`formobile-campo ${editando ? "formobile-campo-editavel" : ""}`}>
                    <label className="formobile-campo-label">E-mail</label>
                    {editando ? (
                      <TextField
                        size="small"
                        fullWidth
                        value={emailEdit}
                        onChange={(e) => setEmailEdit(e.target.value)}
                        inputProps={{ maxLength: 256 }}
                      />
                    ) : (
                      <span className="formobile-campo-valor">
                        {resultado?.email || "-"}
                      </span>
                    )}
                  </div>
                  <div className="formobile-campo">
                    <label className="formobile-campo-label">Categoria</label>
                    <span className="formobile-campo-valor">
                      {resultado?.categoria || "-"}
                    </span>
                  </div>
                  <div className="formobile-campo">
                    <label className="formobile-campo-label">Saldo</label>
                    <span className="formobile-campo-valor">
                      {resultado?.saldo?.toLocaleString("pt-BR") || "0"}
                    </span>
                  </div>
                </div>
                {editando && (
                  <button
                    type="button"
                    className="btn btn-warning formobile-btn"
                    onClick={salvarCadastro}
                  >
                    SALVAR
                  </button>
                )}
                {cadastroSalvo && (
                  <span className="formobile-salvo-msg">
                    Dados atualizados com sucesso!
                  </span>
                )}
              </div>
            )}


            {/* Resgate concluído com voucher (tela 7) */}
            {voucher && (
              <div className="formobile-voucher">
                <strong className="formobile-parabens">PARABÉNS!</strong>
                <p>
                  É quase seu! Informe a um dos nossos representantes o código
                  abaixo:
                </p>
                <span className="formobile-codigo">{voucher}</span>
              </div>
            )}
          </div>
        )}
      </main>

      <footer className="formobile-footer">
        <div className="row p-2">
          <div className="col-md-8 d-flex justify-content-center p-5">
            <div className="d-flex align-items-center flex-column flex-md-row text-sm-center text-md-start">
              <img
                src={logoLeo}
                alt="Leo Madeiras"
                className="formobile-footer-logo"
              />
              <div className="ms-3">
                <div className="formobile-footer-titulo">
                  Leo Madeiras, Máquinas e Ferragens
                </div>
                <div>
                  Rua Doutor Carlos Roberto Presgrave de Melo, 21 - 0800-591-0127
                  - CEP: 06422-110 - São Paulo/SP
                </div>
                <div>
                  CNPJ: 61.069.373/0001-03 | Inscrição Estadual: 112.625.312.111
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 d-flex justify-content-center p-5">
            <div className="d-flex align-items-center">
              <div className="ms-3 d-flex justify-content-end flex-column">
                <div>Siga nossas redes:</div>
                <div className="d-flex justify-content-around">
                  <FacebookIcon className="pointer" onClick={() => window.open("https://www.facebook.com/LeoMadeiras")} />
                  <InstagramIcon className="pointer" onClick={() => window.open("https://www.instagram.com/leomadeiras")} />
                  <YouTubeIcon className="pointer" onClick={() => window.open("https://www.youtube.com/channel/UCcytRsBD6dNhosoX6gpzEmA")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
